const TENANT_TYPES = new Set(["inquilino", "tenant", "client"]);
const OWNER_TYPES = new Set(["proprietario", "owner"]);

export type OwnerRoleUser = {
  type?: string | null;
  is_sub_login?: boolean | null;
  master_user_id?: number | null;
} | null | undefined;

/**
 * Account roles used across menus and dashboards.
 * Missing/empty type is treated as tenant — same convention as Header and Proposals.
 * Also accepts English aliases returned by some auth endpoints (tenant/owner).
 */
export function isTenantUser(user: { type?: string | null } | null | undefined): boolean {
  if (!user) {
    return false;
  }

  if (!user.type) {
    return true;
  }

  return TENANT_TYPES.has(String(user.type).toLowerCase());
}

export function isOwnerUser(user: { type?: string | null } | null | undefined): boolean {
  if (!user) {
    return false;
  }

  if (!user.type) {
    return false;
  }

  return OWNER_TYPES.has(String(user.type).toLowerCase());
}

/**
 * Master owner may manage alternate emails (Gestão de Acessos).
 * Matches backend contract: proprietario/owner and not a sub-login.
 */
export function canManageSubLogins(user: OwnerRoleUser): boolean {
  if (!isOwnerUser(user)) {
    return false;
  }

  // Treat missing is_sub_login as master (legacy sessions before the field existed).
  return user?.is_sub_login !== true;
}

/** @deprecated Prefer canManageSubLogins — kept for existing call sites. */
export function isMasterOwner(user: OwnerRoleUser): boolean {
  return canManageSubLogins(user);
}

export function isSubLoginOwner(user: OwnerRoleUser): boolean {
  return isOwnerUser(user) && user?.is_sub_login === true;
}
